import React from 'react'

import { Visible } from 'main/ui'
import { IFilters } from 'main/util/search'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../common'
import { i18nKeyPrefix } from '../../../../i18n'
import { FilterFormContainer } from '../common'
import { Apply, Clear, FilterFormSubmitContainer } from '../common/FilterForm.styles'
import { ISearchFormProps } from '../types'
import { Fields } from './Fields'

const PRE = `${i18nKeyPrefix}-FILTERS-AVAILABILITY-FORM`

export default function FilterForm(props: ISearchFormProps) {
  const { filters, onChangeFilters, onRequestCloseForm } = props
  const [params, setParams] = React.useState<IFilters>({ ...filters })
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <FilterFormContainer>
      <Fields params={params} onChangeParams={setParams} />
      <Visible lg xl>
        <FilterFormSubmitContainer>
          <Clear data-pendo="availabilityFilter-clear" onClick={() => handleClear()}>
            {t(`${PRE}-CLEAR`)}
          </Clear>
          <Apply data-pendo="availabilityFilter-apply" onClick={() => handleApply()}>
            {t(`${PRE}-APPLY`)}
          </Apply>
        </FilterFormSubmitContainer>
      </Visible>
    </FilterFormContainer>
  )
  function handleApply() {
    onRequestCloseForm()
    onChangeFilters({ ...filters, hasAvailability: params.hasAvailability })
  }

  function handleClear() {
    setParams({ ...params, hasAvailability: false })
  }
}
